import React from 'react';
import {
  PIXANO_APPLE_STORE_URL,
  PIXANO_GOOGLE_PLAY_URL,
  homepageSectionContainerClassName,
  storeButtonClassName,
} from '../constants/homepageUi';

const AppDownloadStrip: React.FC = () => {
  return (
    <div className="border-t border-white/[0.06] bg-[#0B0F14]">
      <div
        className={`${homepageSectionContainerClassName} flex flex-col gap-4 py-5 sm:flex-row sm:items-center sm:justify-between lg:py-6`}
      >
        <div className="min-w-0 sm:max-w-xl">
          <h2 className="text-base sm:text-lg font-semibold text-white tracking-tight">
            Download the Pixano App
          </h2>
          <p className="mt-1 text-sm text-white/85 leading-relaxed">
            Contribute real-world photo and video data through the Pixano app.
          </p>
        </div>
        <div className="flex flex-row flex-wrap items-center gap-2 sm:gap-3 shrink-0">
          <a
            href={PIXANO_APPLE_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={storeButtonClassName}
          >
            Apple Store
          </a>
          <a
            href={PIXANO_GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={storeButtonClassName}
          >
            Google Play
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadStrip;
